import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function ChevronArrowTop(): React.ReactElement {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5L5 1L9 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
